import { GovernmentServiceTokenModel } from "@ntprsrf-frontend/service/src/models/internet/governmentService.model";
import { Router } from "vue-router";
import { corppassLogin, redirectProcess } from "@ntprsrf-frontend/common/src/utils/corppass";
import { firstValueFrom, map } from "rxjs";
import { getGovtServiceById } from "@ntprsrf-frontend/service/src/services/internet/governmentEServices.service";

const transactionalServiceRoutes = [
	{
		name: "permit-clearance-enquiry",
		id: "ntp-5023",
	},
	{
		name: "container-track-and-trace",
		id: "ntp-5024",
	},
	{
		name: "search",
		id: "ntp-5021",
	},
	{
		name: "permit-return",
		id: "ntp-5021",
	},
	{
		name: "hand-carried-exports-scheme",
		id: "ntp-5025",
	},
]

const checkIfTransactional = (portal: GovernmentServiceTokenModel) => {
	const route = transactionalServiceRoutes.filter(v => portal.redirectURL.includes(v.name)).at(0);

	if(route) {
		if(window.wogaaCustom) window.wogaaCustom.startTransactionalService(route.id);
	}
}

export const postLoginFormSubmission = (token: string, state: string, redirectUrl: string) => {
	const form = document.createElement('form');
	const tokenInput = document.createElement('input');
	tokenInput.value = token
	tokenInput.name = 'id_token';
	tokenInput.type = 'hidden';

	const stateInput = document.createElement('input');
	stateInput.value = state
	stateInput.name = 'state';
	stateInput.type = 'hidden';

	form.appendChild(tokenInput);
	form.appendChild(stateInput);

	form.method = 'post';
	form.action = `${redirectUrl}`;
	form.target = '_self';

	document.body.appendChild(form);

	form.submit();
	form.remove();
}

export const redirectToGovtUrl = (
    portal: GovernmentServiceTokenModel,
    isLogin: boolean,
    router: Router
) => {
	const checkIsURLAbsolute = (url: string) => {
		const r = /^(?:[a-z+]+:)?\/\//i;
		return r.test(url); // if true then it is an absolute path
	}
	
    if(portal.govtServiceAccessType === "POST_LOGIN") {
		postLoginFormSubmission(portal.token, portal.state, portal.redirectURL);
	} else if(portal.govtServiceAccessType === "POST_LOGIN_INTERNAL") {
		if(isLogin) {
			checkIfTransactional(portal);
			if (checkIsURLAbsolute(portal.redirectURL)) {
				window.open(
					portal.redirectURL,
					"_self",
					"noopener,noreferrer"
				);
			} else {
				router.push({
					path: portal.redirectURL
				});
			}
		}
		else {
			corppassLogin(portal.redirectURL);
		}
	} else {
		checkIfTransactional(portal);
		if (checkIsURLAbsolute(portal.redirectURL)) {
			window.open(
				portal.redirectURL,
				"_self",
				"noopener,noreferrer"
			);
		} else {
			router.push({
				path: portal.redirectURL
			});
		}
	}
}

export const redirectAfterCorpass = async (
    authStore: {
		isLogin: boolean,
		isFirstLogin: boolean
	},
    router: Router,
	serviceDetailId?: string | null,
) => {
	if (localStorage.getItem('serviceDetailId')) {
		serviceDetailId = localStorage.getItem('serviceDetailId');
		localStorage.removeItem('serviceDetailId');
	}

	if(serviceDetailId) {
		if (authStore.isFirstLogin) {
			await router.push({
				name: "TERMS_AND_CONDITIONS",
				query: {
					redirect: serviceDetailId
				}
			});
			return;
		}
		
		const response = await firstValueFrom(
			getGovtServiceById(serviceDetailId).pipe(map(res => res.data)),
		);
		
		redirectToGovtUrl(response, authStore.isLogin, router);
		
		if (response.govtServiceAccessType === "POST_LOGIN") {
			router.push({
				name: 'GOVERNMENT_SERVICES_LIST'
			})
		}

		return;
	}
	redirectProcess(router);
}
